const accountManagementActionTypes = {
  FETCH_USER_AUTHENTICATION_INFO: 'FETCH_USER_AUTHENTICATION_INFO',
  FETCH_USER_AUTHENTICATION_INFO_SUCCESS: 'FETCH_USER_AUTHENTICATION_INFO_SUCCESS',
  FETCH_USER_AUTHENTICATION_INFO_FAIL: 'FETCH_USER_AUTHENTICATION_INFO_FAIL',

  FETCH_LOGIN_INFO: 'FETCH_LOGIN_INFO',
  FETCH_LOGIN_INFO_SUCCESS: 'FETCH_LOGIN_INFO_SUCCESS',
  FETCH_LOGIN_INFO_FAIL: 'FETCH_LOGIN_INFO_FAIL',
};

export default accountManagementActionTypes;
